import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import EPromoteSlider1 from "../components/elderyContent/E_PromoteSlider1";
import MobileEPSlider1 from "../components/elderyContent/MobileE_P_Slider1";
import EReferSlider1 from "../components/elderyContent/E_ReferSlider1";
import MobileERSlider1 from "../components/elderyContent/MobileE_R_Slider1";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: 1440,
    width: "100%",
    height: 2500,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    maxWidth: 1290,
    width: "100%",
    flexGrow: 1,
    alignSelf: "center",
    display: "block",
  },
  container0: {
    width: 854,
    margin: "50px 0px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "left",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginTop: 0,
      marginLeft: 20,
      justifyContent: "flex-start",
    },
  },
  slideBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  slider: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    marginBottom: "50px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  mobileSlider: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      display: "flex",
      width: "100%",
      justifyContent: "center",
      flexDirection: "column",
      marginBottom: 50,
    },
  },
  conHeader: {
    display: "flex",
    paddingLeft: "75px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      justifyContent: "center",
      paddingLeft: "0px",
      marginBottom: "10px",
    },
  },
  BlackLine: {
    width: 853,
    borderTop: "1px solid #000",
    marginTop: "6px",
    marginBottom: "25px",
    alignSelf: "center",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  newBox: {
    width: 854,
    height: 485,
    background: "#c4c4c4",
    marginTop: 20,
    marginBottom: 50,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 0,
    },
  },
}));

export const ElderyContentPage3 = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      {/* Body start */}
      <div className={classes.body}>
        <div className={classes.container}>
          <div className={classes.container0}>
            <img
              src={halfCircleBlue}
              alt="blueHalfCircle"
              className={classes.halfCircleBlue}
            />
            <Typography variant="elderNews" className={classes.top_text}>
              휴먼브릿지 홍보 영상
            </Typography>
          </div>
        </div>
        <div className={classes.slideBox}>
          <div className={classes.slider}>
            <Typography variant="ContentHeader3" className={classes.conHeader}>
              홍보 영상 1
            </Typography>
            <div className={classes.BlackLine}></div>
            <EPromoteSlider1 />
          </div>
          <div className={classes.mobileSlider}>
            <Typography variant="ContentHeader3" className={classes.conHeader}>
              홍보 영상 1
            </Typography>
            <MobileEPSlider1 />
          </div>
          <div className={classes.slider}>
            <Typography variant="ContentHeader3" className={classes.conHeader}>
              홍보 영상 2
            </Typography>
            <div className={classes.BlackLine}></div>
            <EReferSlider1 />
          </div>
          <div className={classes.mobileSlider}>
            <Typography variant="ContentHeader3" className={classes.conHeader}>
              홍보 영상 2
            </Typography>
            <MobileERSlider1 />
          </div>
          {/* <div>
            <ElderyTabs />
          </div> */}
        </div>
        {/* Body End */}

        {/* Footer start*/}
        <div>
          <Footer />
        </div>
        {/* Footer end */}

        {/* Mobile Footer start */}
        <div style={{ display: "flex" }}>
          <MobileFooter />
        </div>
        {/* Mobile Footer end */}
      </div>
    </div>
  );
};
